<div class="col-12 mb-4">
  <h5><strong>Product Details</strong></h5>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th class="table-header">Product Category</th>
        <th class="table-header">Item Description</th>
        @if(jobDetails?.dispatchByUnits){<th class="table-header">Dispatch Units</th>}
        <th class="table-header">
          @if(isContractJob()){ {{getContractUom()}} }
          @if(!isContractJob()){ Quantity }
        </th>
        @if(!isContractJob()){<th class="table-header">Weight (tonne)</th>}
        @if(!isContractJob()){<th class="table-header">Volume (m3)</th>}
      </tr>
    </thead>
    @if(!isContractJob()){
    <tbody>
      @for(product of jobProducts; track $index){
      <tr>
        <td [attr.rowspan]="(product?.productItems?.length ?? 0) + 1">
          {{product?.productCategory?.name
          || ''}}
        </td>
      </tr>
      @for(item of product.productItems; track $index){
      <tr>
        <td>{{ item.itemDescription }}</td>
        @if(jobDetails?.dispatchByUnits){<td>&nbsp;</td>}
        <td>{{ item.quantity }}</td>
        <td>{{ item.weight}}</td>
        <td>{{ item.volume}}</td>
      </tr>
      }
      }
    </tbody>
    }@else{
    <tbody>
      @for(product of jobProducts; track $index){
      <tr>
        <td>
          <b>{{product?.productCategory?.name
            || ''}}</b>
        </td>
        <td>{{ product.productDescription }}</td>
        @if(jobDetails?.dispatchByUnits) {<td>{{
          product.dispatchQuantity }}</td>}
        <td>{{ product.quantity }}</td>
        @if(!isContractJob()){ <td></td> }
        @if(!isContractJob()){ <td></td> }
      </tr>
      }
    </tbody>
    }
  </table>
</div>